export const SystemRoleName = {
  SUPER_ADMIN: 'SUPER_ADMIN',
  ORGANIZATION_MANAGER: 'ORGANIZATION_MANAGER',
  SUPERVISOR: 'SUPERVISOR',
  FIELD_TECHNICIAN: 'FIELD_TECHNICIAN',
  /** Non-interactive actor for cron / system writes (no permissions). */
  SYSTEM: 'SYSTEM',
} as const;

export type SystemRoleName =
  (typeof SystemRoleName)[keyof typeof SystemRoleName];

export const SYSTEM_ROLE_NAMES: readonly SystemRoleName[] = [
  SystemRoleName.SUPER_ADMIN,
  SystemRoleName.ORGANIZATION_MANAGER,
  SystemRoleName.SUPERVISOR,
  SystemRoleName.FIELD_TECHNICIAN,
  SystemRoleName.SYSTEM,
];

export const EDITABLE_SYSTEM_ROLE_NAMES = [
  SystemRoleName.ORGANIZATION_MANAGER,
  SystemRoleName.SUPERVISOR,
  SystemRoleName.FIELD_TECHNICIAN,
] as const;

export type EditableSystemRoleName =
  (typeof EDITABLE_SYSTEM_ROLE_NAMES)[number];

/**
 * Non-interactive / infrastructure system roles that must never appear in
 * role management UI or list APIs (including for SUPER_ADMIN).
 */
export const HIDDEN_SYSTEM_ROLE_NAMES = [SystemRoleName.SYSTEM] as const;

export type HiddenSystemRoleName = (typeof HIDDEN_SYSTEM_ROLE_NAMES)[number];

const SYSTEM_ROLE_NAME_SET = new Set<string>(SYSTEM_ROLE_NAMES);
const EDITABLE_SYSTEM_ROLE_NAME_SET = new Set<string>(
  EDITABLE_SYSTEM_ROLE_NAMES,
);
const HIDDEN_SYSTEM_ROLE_NAME_SET = new Set<string>(HIDDEN_SYSTEM_ROLE_NAMES);

export function isSystemRoleName(value: string): value is SystemRoleName {
  return SYSTEM_ROLE_NAME_SET.has(value);
}

export function isEditableSystemRoleName(
  value: string,
): value is EditableSystemRoleName {
  return EDITABLE_SYSTEM_ROLE_NAME_SET.has(value);
}

export function isHiddenSystemRoleName(
  value: string,
): value is HiddenSystemRoleName {
  return HIDDEN_SYSTEM_ROLE_NAME_SET.has(value);
}
